<template>
  <div class="contents">
    <div class="customer_wrap">
      <div class="cs_card">
          <div class="box">
              <img src="../../assets/images/common/ico_cs.png" alt="고객센터 이용안내">
              <p>고객센터 이용안내</p>
              <h5>070.4233.0655</h5>
              <span>FAX : 02)478-5822</span>
          </div>
          <p>운영시간</p>
          <span>월-금 09:00~17:30</span>
      </div>
      <div class="cs_tab">
        <ApiGuideNavigation/>
        <div class="cs_tabPanel active" id="cs_tab01">
          <h5 class="title">API 가이드</h5>
          <div class="api_guide_wrap">
            <h4>1. 거래처 인증 토큰 발행</h4>
            <div class="api_section">
              <h5 class="post">요청</h5>
              <p>API 주소 : <span class="post">POST</span> https://www.blossomlogos.com/api/company/auth</p>
              <p>Content-Type : application/json; charset=UTF-8</p>

              <table class="api_tbl">
                <thead>
                  <tr>
                    <th>항목명</th><th>타입</th><th>필수 여부</th><th>길이</th><th>내용</th><th>비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>TYPE</td><td>STRING</td><td>O</td><td>10</td><td>유형</td><td></td></tr>
                  <tr><td>COMID</td><td>STRING</td><td>O</td><td>50</td><td>거래처코드</td><td></td></tr>
                  <tr><td>SECRETKEY</td><td>STRING</td><td>O</td><td>50</td><td>비밀키</td><td></td></tr>
                  <tr><td>BUSINESSNUM</td><td>STRING</td><td>O</td><td>30</td><td>사업자번호</td><td></td></tr>
                </tbody>
              </table>

              <h5 class="post">응답</h5>
              <p>HTTP/1.1 <span class="ok">200 OK</span></p>
              <p>Content-Type : application/json; charset=UTF-8</p>

              <table class="api_tbl">
                <thead>
                  <tr>
                    <th>항목명</th><th>타입</th><th>필수 여부</th><th>길이</th><th>내용</th><th>비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>TYPE</td><td>STRING</td><td>O</td><td>10</td><td>유형</td><td></td></tr>
                  <tr><td>COMID</td><td>STRING</td><td>O</td><td>50</td><td>거래처코드</td><td></td></tr>
                  <tr><td>TOKEN</td><td>STRING</td><td>O</td><td>50</td><td>HASH CODE</td><td></td></tr>
                </tbody>
              </table>
            </div>

            <h4>2. 부고장 생성</h4>
            <div class="api_section">
              <h5 class="post">요청</h5>
              <p>API 주소 : <span class="post">POST</span> https://www.blossomlogos.com/api/company/funeral</p>
              <p>Content-Type : application/json; charset=UTF-8</p>
              <p>Authorization : Bearer</p>

              <table class="api_tbl">
                <thead>
                  <tr>
                    <th>항목명</th><th>타입</th><th>필수 여부</th><th>길이</th><th>내용</th><th>비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>Location</td><td>STRING</td><td>O</td><td>255</td><td>장례식장명</td><td></td></tr>
                  <tr><td>LocationCode</td><td>STRING</td><td>O</td><td>255</td><td>장례식장 코드</td><td></td></tr>
                  <tr><td>LocationSection</td><td>STRING</td><td>O</td><td>255</td><td>호실 코드</td><td></td></tr>
                  <tr><td>DeceasedName</td><td>STRING</td><td>O</td><td>255</td><td>고인명</td><td></td></tr>
                  <tr><td>DeathDate</td><td>STRING</td><td>O</td><td>255</td><td>입졸일시</td><td></td></tr>
                  <tr><td>FuneralDate</td><td>STRING</td><td>O</td><td>255</td><td>발인일시</td><td></td></tr>
                  <tr><td>Mourner</td><td>STRING</td><td>O</td><td>255</td><td>대표 상주명</td><td></td></tr>
                  <tr><td>MournerPhone</td><td>STRING</td><td>O</td><td>255</td><td>대표 상주연락처</td><td></td></tr>
                </tbody>
              </table>

              <h5 class="post">응답</h5>
              <p>HTTP/1.1 <span class="ok">200 OK</span></p>
              <p>Content-Type : application/json; charset=UTF-8</p>
              <p>부고장 생성 요청 시 캠페인 선택창이 팝업으로 표시됩니다.</p>

              <table class="api_tbl">
                <thead>
                  <tr>
                    <th>항목명</th><th>타입</th><th>필수 여부</th><th>길이</th><th>내용</th><th>비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>TYPE</td><td>STRING</td><td>O</td><td>10</td><td>유형</td><td></td></tr>
                  <tr><td>COMID</td><td>STRING</td><td>O</td><td>50</td><td>거래처코드</td><td></td></tr>
                  <tr><td>URL</td><td>STRING</td><td>O</td><td>100</td><td>디지털화환 URL</td><td></td></tr>
                </tbody>
              </table>
            </div>

            <h4>3. 디지털화환 구매창</h4>
            <div class="api_section">
              <h5 class="post">요청</h5>
              <p>API 주소 : <span class="get">GET</span> https://www.blossomlogos.com/company/invitation/<span class="get">{주문번호}</span></p>
              <p>Content-Type : application/json; charset=UTF-8</p>

              <h5 class="post">응답</h5>
              <p>HTTP/1.1 <span class="ok">200 OK</span></p>
              <p>디지털화환 구매를 위한 창입니다.</p>

              <table class="api_tbl">
                <thead>
                  <tr>
                    <th>항목명</th><th>타입</th><th>필수 여부</th><th>길이</th><th>내용</th><th>비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>TYPE</td><td>STRING</td><td>O</td><td>10</td><td>유형</td><td></td></tr>
                  <tr><td>COMID</td><td>STRING</td><td>O</td><td>50</td><td>거래처코드</td><td></td></tr>
                  <tr><td>URL</td><td>STRING</td><td>O</td><td>100</td><td>디지털화환 URL</td><td></td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ApiGuideNavigation from '@/views/apiGuide/layout/ApiGuideNavigation.vue';

export default {
  components: {
    ApiGuideNavigation
  },
}

</script>

<style scoped>
.api_guide_wrap {
  padding: 40px;
  background: #fff;
  color: #222;
  font-family: 'Pretendard', sans-serif;
  line-height: 1.6;
}

.api_guide_wrap h4 {
  font-size: 20px;
  font-weight: bold;
  margin-top: 40px;
  border-bottom: 2px solid #000;
  padding-bottom: 5px;
}

.api_section {
  margin-top: 15px;
}

.api_section h5 {
  margin-top: 15px;
  font-size: 16px;
  font-weight: bold;
}

.api_tbl {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
}

.api_tbl th, .api_tbl td {
  border: 1px solid #ccc;
  padding: 6px 8px;
  font-size: 13px;
  text-align: center;
}

.api_tbl th {
  background: #f5f5f5;
  font-weight: bold;
}

.post { color: #c7254e; font-weight: bold; }
.get { color: #3d7e9a; font-weight: bold; }
.ok { color: #009900; font-weight: bold; }
</style>